// extracted by mini-css-extract-plugin
export default {"userNotesContainer":"userNotesContainerRYpyn"};